import { memo } from "react";
import { VStack } from "@/shared/ui/Stack";
import { TEXT_SIZES } from "../../constants/textSizes";
import { MenuButton } from "../MenuButton/MenuButton";

interface TextSizeMenuContentProps {
    onTextSizeButtonClick: (size: number) => void;
}

export const TextSizeMenuContent = memo(function TextSizeMenuContent({
    onTextSizeButtonClick,
}: TextSizeMenuContentProps) {
    return (
        <VStack>
            {TEXT_SIZES.map((size) => (
                <MenuButton key={size} onClick={() => onTextSizeButtonClick(size)}>
                    {size}
                </MenuButton>
            ))}
        </VStack>
    );
});
